import React, { Component } from "react";
import { connect } from "react-redux";
import { selectRate } from "../../actions";
import LOGO from "../../../assets/box-in-logo-green.svg";
import LOGO_WHITE from "../../../assets/box-in-logo.svg";
import MessageBlock from "../common/MessageBlock";
import ToolTip from "../common/ToolTip";
import { FiAlertCircle, FiInfo } from "react-icons/fi";
import { parseError } from "../../actions/ActionHelpers";

const SERVICE_TOKEN_TOOLTIPS = {
  shipshap_0:
    "If booked before 12pm (noon) on a business day, delivered by the end of that business day.",
  shipshap_next_day_delivery:
    "If booked by 4pm on a business day, delivered by the end of the next business day.",
};

const getServiceTokenTooltip = (serviceToken) =>
  SERVICE_TOKEN_TOOLTIPS[serviceToken] ?? null;

const RateItem = ({
  selectRate,
  isSelected,
  rateIcon,
  rateProvider,
  rateName,
  serviceToken,
  terms,
  discountedAmount,
  amount,
  currency,
}) => {
  const tooltipMessage = getServiceTokenTooltip(serviceToken);
  const renderDetails = (features) => {
    return <p>{features}</p>;
  };

  return (
    <div
      className={`rate-item col-12 ${isSelected ? "active" : ""}`}
      onClick={selectRate}
      onKeyDown={selectRate}
      role={"button"}
    >
      <div className="col-12 p-0 d-flex flex-row">
        <img
          src={rateIcon}
          className="rate-icon col-2 p-0 "
          alt={rateProvider}
        />
        <div className="d-flex flex-column">
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-column">
              <h4>{rateProvider}</h4>
              <h5 className="d-flex flex-row align-items-center">
                {rateName}
                {tooltipMessage && (
                  <span onClick={(e) => e.stopPropagation()}>
                    <ToolTip
                      keyValue={`rate-service-${serviceToken}`}
                      message={tooltipMessage}
                      placement="auto"
                      className="rate-service-tooltip"
                    />
                  </span>
                )}
              </h5>
            </div>
          </div>
          {terms && (
            <div className="rate-features p-0 d-flex flex-column">
              {renderDetails(terms)}
            </div>
          )}
        </div>
        <div className="d-flex flex-column ml-auto text-end">
          <p
            className={`price ${discountedAmount ? "discounted" : ""}`}
          >{`${parseFloat(amount).toFixed(2)} ${currency}`}</p>
          {discountedAmount ? (
            <p className="price">{`${parseFloat(discountedAmount).toFixed(2)} ${currency}`}</p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

class RateSelection extends Component {
  renderDetails = (features) => {
    return <p>{features}</p>;
  };

  sortRates = () => {
    const rates = [...this.props.rates];
    return (
      Array.isArray(rates) &&
      rates.sort((rate1, rate2) => {
        const rateOneAmount = rate1.discounted_amount
          ? parseFloat(rate1.discounted_amount)
          : parseFloat(rate1.amount);
        const rateTwoAmount = rate2.discounted_amount
          ? parseFloat(rate2.discounted_amount)
          : parseFloat(rate2.amount);
        return rateOneAmount - rateTwoAmount;
      })
    );
  };

  renderSingle = (selected) => {
    const sortedRates = this.sortRates();
    let min = sortedRates?.length > 0 ? this.sortRates()[0] : null;
    if (!min) return <></>;

    return (
      <RateItem
        isSelected={selected === min.id}
        selectRate={() => this.props.selectRate({ rate: min })}
        rateIcon={selected === min.id ? LOGO_WHITE : LOGO}
        rateProvider={"ShipShap"}
        rateName={`${this.props.sender?.country === this.props.receiver?.country ? "Local" : "International"} Rate`}
        currency={min.currency}
        amount={min.amount}
        discountedAmount={min.discounted_amount}
        terms={min.service.terms}
        serviceToken={min.service.token}
      />
    );
  };

  renderAll = (selected) => {
    const sortedRates = this.sortRates();
    if (!sortedRates || sortedRates?.length == 0) return <></>;
    return sortedRates.map((item) => {
      return (
        <RateItem
          isSelected={selected === item.id}
          selectRate={() => this.props.selectRate({ rate: item })}
          rateIcon={item.service.provider_image}
          rateProvider={item.service.provider}
          rateName={item.service.name}
          currency={item.currency}
          amount={item.amount}
          discountedAmount={item.discounted_amount}
          terms={item.service.terms}
          serviceToken={item.service.token}
        />
      );
    });
  };

  renderList = () => {
    const id = this.props.selectedRate && this.props.selectedRate.id;
    if (this.props.rates.length === 0) {
      return (
        <div className="empty-list justify-content-center align-items-center text-center">
          <p className={"m-lg-auto text-lg-center"}>
            Request rates with the shipment details to see rates
          </p>
        </div>
      );
    }
    return (
      <div className="list-container ">
        <div className={""}>
          {this.props.email === "kebron@viditure.com"
            ? null
            : this.props.showCarriers
              ? this.renderAll(id)
              : this.renderSingle(id)}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="rates-selection settings-card ">
        <div className={"rates-container "}>
          <div className="rates-title card-section head ">
            <div className="text-title d-flex flex-column justify-content-start align-items-start">
              <h3 className="text-title">Rates</h3>
            </div>
          </div>
          <div className=" rates-list card-section last d-flex flex-column align-items-center">
            {this.props.rates.length > 0 && (
              <p className="info mr-auto text-">
                Select Your prefered shipping service & rate
              </p>
            )}
            {!this.props.loading && this.props.warnings && (
              <MessageBlock
                type={"warning"}
                message={parseError(this.props.warnings)}
                icon={<FiInfo />}
              />
            )}
            {this.props.loading ? (
              <div className="spinner-border text-dark"></div>
            ) : this.props.errors ? (
              <MessageBlock
                type={"error"}
                message={parseError(this.props.errors)}
                icon={<FiAlertCircle />}
              />
            ) : (
              <div className={"col-12 p-0"}>{this.renderList()}</div>
            )}

            {this.props.rates.length === 0 ? (
              <div></div>
            ) : (
              <div className=" align-items-center justify-content-center">
                <button
                  className="purchase-button"
                  disabled={
                    !(this.props.selectedRate && this.props.selectedRate.id)
                  }
                  onClick={() => this.props.togglePurchase()}
                >
                  Purchase Label
                </button>
              </div>
            )}
          </div>
          <br />
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({
  rateChoices,
  senderAddress,
  receiverAddress,
  userDetails,
}) => ({
  rates: rateChoices.rates,
  selectedRate: rateChoices.selectedRate,
  loading: rateChoices.loading,
  errors: rateChoices.errors,
  warnings: rateChoices.warnings,
  sender: senderAddress,
  receiver: receiverAddress,
  showInternational: userDetails.info?.show_international_carriers,
  isImpersonation: userDetails?.info?.is_impersonated,
  email: userDetails?.info?.email,
});

export default connect(mapStateToProps, { selectRate })(RateSelection);
